import React from "react";
import { Volume2, Loader2 } from "lucide-react";
import { useWordTTS } from "../hooks/useKabyleTTS";

interface TTSButtonProps {
  text: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const TTSButton: React.FC<TTSButtonProps> = React.memo(({
  text,
  className = "",
  size = "md"
}) => {
  const { isPlaying, isLoading, play } = useWordTTS(text);

  const iconSizes = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  const padSizes = {
    sm: "p-2 min-w-[36px] min-h-[36px]",
    md: "p-2 min-w-[40px] min-h-[40px]",
    lg: "p-2.5 min-w-[44px] min-h-[44px]",
  };

  return (
    <button
      type="button"
      aria-label={`Écouter la prononciation de ${text}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        play();
      }}
      className={`inline-flex items-center justify-center rounded-full transition-all cursor-pointer select-none ${padSizes[size]} ${
        isPlaying
          ? "text-cyan-300 bg-cyan-900/70 ring-2 ring-cyan-400 scale-105 shadow-[0_0_10px_rgba(6,182,212,0.6)]"
          : "text-slate-400 hover:text-cyan-300 hover:bg-slate-800/80 active:scale-95"
      } ${className}`}
      title="Écouter la prononciation"
    >
      {isLoading ? (
        <Loader2 className={`${iconSizes[size]} animate-spin text-cyan-400`} />
      ) : (
        <Volume2
          className={`${iconSizes[size]} ${
            isPlaying ? "animate-pulse text-cyan-300" : ""
          }`}
        />
      )}
    </button>
  );
});
